import { render, staticRenderFns } from "./PendingTransactions.vue?vue&type=template&id=41415060&scoped=true"
import script from "./PendingTransactions.vue?vue&type=script&lang=js"
export * from "./PendingTransactions.vue?vue&type=script&lang=js"
import style0 from "./PendingTransactions.vue?vue&type=style&index=0&id=41415060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41415060",
  null
  
)

export default component.exports